import { SignInGate } from '@casa/kaoto-extension/auth';
import { createHashRouter } from 'react-router-dom';

import App from './App';
import { getPluginPages } from './components/registers/plugin-pages';
import { ErrorPage } from './pages/ErrorPage';
import { ReloadProvider } from './providers';
import { Links } from './router/links.models';

export const router = createHashRouter([
  {
    path: Links.Home,
    element: (
      <SignInGate>
        <ReloadProvider>
          <App />
        </ReloadProvider>
      </SignInGate>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        lazy: async () => import('./pages/Design'),
      },
      {
        path: Links.SourceCode,
        lazy: async () => import('./pages/SourceCode'),
      },
      {
        path: Links.Topology,
        lazy: async () => import('./pages/Topology'),
      },
      {
        path: Links.RestImport,
        lazy: async () => import('./pages/RestDslImport'),
      },
      {
        path: Links.RestEditor,
        lazy: async () => import('./pages/RestDslEditor'),
      },
      {
        path: Links.Catalog,
        lazy: async () => import('./pages/Catalog'),
      },
      {
        path: Links.Beans,
        lazy: async () => import('./pages/Beans'),
      },
      {
        path: Links.Metadata,
        lazy: async () => import('./pages/Metadata'),
      },
      {
        path: Links.PipeErrorHandler,
        lazy: async () => import('./pages/PipeErrorHandler'),
      },
      {
        path: Links.Settings,
        lazy: async () => import('./pages/Settings'),
      },
      ...getPluginPages().map((page) => ({
        path: page.path,
        element: <page.component />,
      })),
      {
        path: Links.DataMapper,
        lazy: async () => import('./pages/DataMapper/DataMapperWorkspacePage'),
      },
      {
        path: `${Links.DataMapper}/:id`,
        lazy: async () => import('./pages/DataMapper'),
      },
    ],
  },
]);
